import getCanAutoplaySilentVideo from "selectors/device/getCanAutoplaySilentVideo";
import getUseCanvasVideo from "selectors/device/getUseCanvasVideo";
import { createSelector } from "reselect";

const getUseNativeVideo = createSelector(
  [getCanAutoplaySilentVideo, getUseCanvasVideo],
  (canAutoplaySilentVideo, useCanvasVideo) =>
    canAutoplaySilentVideo || !useCanvasVideo,
);

export default getUseNativeVideo;
